module.exports = __webpack_public_path__ + "img/box-taped.3caf9df5.svg";